import React, { useState } from "react";
import { Button } from "../ui/button";

const Card = ({ item, type }) => {
  const defaultImage = (type === "crew") ? "/images/misc/profile.png" : "/images/misc/equipment.png";

  // FIX: Handles your API's flat response (equipment_name) or nested response (equipment.equipment_name)
  const name = type === "crew"
    ? `${item?.crew_member?.first_name || ''} ${item?.crew_member?.last_name || 'Unassigned'}`
    : item?.equipment_name || item?.equipment?.equipment_name || "Unknown Equipment";

  const subText = type === "crew"
    ? item?.crew_member?.role_name
    : item?.category || "Equipment";

  return (
    <div className="w-full bg-card rounded-xl border border-light-grey-3 shadow-sm p-3 flex items-center gap-3 mb-3 last:mb-0">
      <img
        src={defaultImage}
        alt={name}
        className="w-10 h-10 rounded-full object-cover bg-slate-100"
      />
      <div className="overflow-hidden">
        <p className="text-sm font-semibold truncate">
          {name}
        </p>
        {subText && <p className="text-[10px] text-gray-500 uppercase tracking-wider">{subText}</p>}
      </div>
    </div>
  );
};

const AssignedList = ({ title, list = [], type }) => {
  const [showAll, setShowAll] = useState(false);

  if (!list || list.length === 0) {
    return (
      <div className="w-full p-4 rounded-lg bg-card border border-dashed border-gray-200">
        <p className="text-sm text-gray-400 text-center">No {type} assigned yet</p>
      </div>
    );
  }

  const visibleList = showAll ? list : list.slice(0, 3);

  return (
    <div className="w-full p-4 rounded-lg bg-card border border-light-grey-3 flex flex-col gap-4">
      <p className="text-base font-bold">{title}</p>
      <div className="flex flex-col">
        {visibleList.map((item, idx) => (
          <Card key={idx} item={item} type={type} />
        ))}
      </div>
      {list.length > 3 && (
        <Button
          variant="ghost"
          className="text-blue-600 hover:text-blue-700 text-xs font-bold h-8"
          onClick={() => setShowAll(!showAll)}
        >
          {showAll ? "View Less" : `View all (${list.length})`}
        </Button>
      )}
    </div>
  );
};

export default AssignedList;
